var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import styled from "styled-components";
import { T, FONT } from "../admin.theme";
var Pill = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 14px;\n  border-radius: ", "px;\n  background: ", ";\n  border: 1px solid ", ";\n  font-family: ", ";\n  font-size: 13px;\n  color: ", ";\n  cursor: pointer;\n  white-space: nowrap;\n  transition: border-color 160ms, color 160ms;\n\n  &:hover {\n    border-color: ", ";\n  }\n\n  svg {\n    font-size: 16px;\n    color: ", ";\n  }\n"], ["\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 14px;\n  border-radius: ", "px;\n  background: ", ";\n  border: 1px solid ", ";\n  font-family: ", ";\n  font-size: 13px;\n  color: ", ";\n  cursor: pointer;\n  white-space: nowrap;\n  transition: border-color 160ms, color 160ms;\n\n  &:hover {\n    border-color: ", ";\n  }\n\n  svg {\n    font-size: 16px;\n    color: ", ";\n  }\n"])), T.radiusSm, T.surface, function (_a) {
    var $active = _a.$active;
    return ($active ? T.accentTintStrong : T.border);
}, FONT.body, function (_a) {
    var $active = _a.$active;
    return ($active ? T.accent : T.textSecondary);
}, T.accentTintStrong, T.textMuted);
// «Пилюля»-фильтр макета: текст + шеврон, активна когда выбран фильтр.
export var FilterPill = function (_a) {
    var active = _a.active, children = _a.children, rest = __rest(_a, ["active", "children"]);
    return (_jsxs(Pill, __assign({ "$active": active }, rest, { children: [children, _jsx(KeyboardArrowDownIcon, {})] })));
};
var templateObject_1;
